import React from 'react'

import { useAuth } from '@webmotors/consumer-shared-auth'
import {
  PROFILE_LINKS_LOGGED_OUT,
  Header as UIHeader,
} from '@webmotors/consumer-shared-ui'
import '@webmotors/consumer-shared-ui/styles.css'
import { config } from 'config/config'
import { hasHeaderLocationCEP } from '@/utils/utils'
import { window } from 'window-or-global'

const LOGIN_LABEL = 'Entrar na conta'

const PROFILE_LINKS_LOGGED_OUT_OVERRIDE = [
  { label: LOGIN_LABEL, href: '/login' },
  ...PROFILE_LINKS_LOGGED_OUT.filter(link => link.label !== LOGIN_LABEL),
]

const Header = () => {
  const { token } = useAuth()
  const authToken = token ?? undefined
  const loginRedirectUrl = `${config.baseUrl}${window?.location?.pathname}${window?.location?.search}`

  return (
    <UIHeader
      profileLinksLoggedOut={PROFILE_LINKS_LOGGED_OUT_OVERRIDE}
      loginRedirectUrl={loginRedirectUrl}
      baseUrl={config.baseUrl}
      authToken={authToken}
      logoutBehavior="stay"
      dataQaProject="da"
      sticky={false}
      locationApiUrl={config.locationApiUrl}
      showLocation={hasHeaderLocationCEP()}
    />
  )
}

export default Header
